<template>
  <div class="chart-item-filter" @click="onClick">
    <div class="wrapper">
      <div class="chart-wrapper">
        <div class="plus-image" />
        <div class="iol-select">
          <Select v-model="value" :placeholder="'Add IOL'" @input="onInput()">
            <option v-for="iol in iols" :key="iol.model" :value="iol">
              {{iol.model}}
            </option>
          </Select>
        </div> 
      </div>
    </div>
  </div>
</template>

<script>
  import TextChart from 'raypro_ui/src/components/ui/charts/TextChart'
  import Select from 'raypro_ui/src/components/ui/inputs/StyledSelect'
  export default {
    components: {
      TextChart,
      Select,
    },
    data() {
      return {
        value: null,
        selectedIol: null,
      }
    },
    props: {
      iols: {type: Array},
    },
    methods: {
      onClick() {
        this.$emit('onClick')
      },
      onInput() {
        this.$emit('input', this.value)
      },
    },
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'
  @import '../../../stylesheets/helpers/mixins'

  .chart-item-filter
    width: 100%
    max-width: 320px
    position: relative
    background-color: $color-panel-bg
    box-shadow: $color-shadow
    margin-bottom: 30px
    margin-right: 30px
    border-radius: 20px
    -moz-box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.06)
    -webkit-box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.06)
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.06)

    @include media(screen and (min-width: 500px))
      flex-basis: calc(50% - 30px)

    @include media(screen and (min-width: 740px))
      flex-basis: calc(33% - 30px)

    @include media(screen and (min-width: 1000px))
      flex-basis: calc(25% - 30px)

    .wrapper
      padding: 20px
      display: flex
      max-width: 320px
      align-items: center
      flex-direction: column
      justify-content: center

      .chart-wrapper
        width: 100%
        flex: 1
        min-height: 0
        padding-top: 10px

        .plus-image
          background: url('../../../assets/plus-image.png')
          background-size: cover
          background-position: 50% 50%
          position: absolute
          top: 35%
          left: 35%
          width: 30%
          height: 30%

        .iol-select
          position: absolute
          left: 10%
          bottom: 10px
          width: 80%

          .styled-select
            .input-wrapper
              .arrow
                //display: none

        .no-link
          pointer-events: none

        .chart-title
          text-align: center
          position: relative
          left: 50%
          //width: 150px
          color: $color-text
          transform: translateX(-50%)

          h4
            font-size: 14px
            line-height: 1
            // text-align: center
            font-weight: $font-regular
            margin-bottom: 5px
            @include media($media-small)
              font-size: 14px

          h5
            // text-align: center
            font-size: 13px
            font-weight: $font-regular
            color: $color-placeholder

          .active
            display: flex
            flex-direction: row
            justify-content: center
            align-content: center
            align-items: center

            .active-line
              width: 10px
              border-top: 3px solid #299940
              margin-right: 7px

            .active-percent
              font-size: 12px

              @include media($media-small)
                font-size: 10px


            @include media($media-small)
              font-size: 10px

</style>


// WEBPACK FOOTER //
// src/components/pages/Dashboard/ChartItemFilter_v2.vue